class MacroUseButtonUrl {
  constructor(options = {}) {
    this.config = {
      classButtonPrimary: 'primary',
      classButtonLink: 'link',
      modulePrimary: document.querySelectorAll('.js-use-buttonprimary-url'),
      moduleLink: document.querySelectorAll('.js-use-buttonlink-url'),
      rowClickable: [],
      ...options
    };
  }

  init() {
    const {
      classButtonPrimary,
      classButtonLink,
      modulePrimary,
      moduleLink,
      rowClickable
    } = this.config;

    if (!rowClickable.length) {
      return;
    }

    const setMacroClickWithUrlOf = button => {
      const cols = document.querySelectorAll(`.png-col.js-use-button${button}-url`);
      if (cols) {
        rowClickable.forEach(() => {
          cols.forEach(col => {
            const btn = col.querySelector(`.btn-${button}`);
            const macro = col.querySelector('.o-macro');
            if (btn && macro) {
              macro.classList.add('has-link');
              macro.addEventListener('click', () => {
                window.location.href = btn.getAttribute('href');
              });
            }
          });
        });
      }
    };

    if (modulePrimary) {
      modulePrimary.forEach(() => setMacroClickWithUrlOf(classButtonPrimary));
    }

    if (moduleLink) {
      moduleLink.forEach(() => setMacroClickWithUrlOf(classButtonLink));
    }
  }
}

export default MacroUseButtonUrl;
